import React from "react";
function Dec2bin(dec) {
  return (dec >>> 0).toString(2);
}

export default Dec2bin;
